import * as Yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';
import { defaultAddressValidation } from 'app/shared/address-input/model/address.schema';
import { SUBJECT_TYPE_ENUM } from 'app/shared/enumeration/enums';

export const projectDocumentValidationSchema = Yup.object({
  projectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  projectMark: Yup.string().required(messages.MANDATORY_FIELD),
  projectCreatedDate: Yup.date().required(messages.MANDATORY_FIELD),
  authorizedDesigner: Yup.object({
    authorizationNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
    oib: Yup.string().required(messages.MANDATORY_FIELD),
  }),
  designerOffice: Yup.object({
    subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
    legalEntity: Yup.object().when('subjectType', (subjectType, schema) => {
      if (subjectType && subjectType[0] && subjectType[0][0] && subjectType[0][0].id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: Yup.string()
            .required(messages.MANDATORY_FIELD)
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .min(11, messages.OIB_MIN_MAX_LENGTH)
            .max(11, messages.OIB_MIN_MAX_LENGTH),
          mb: Yup.string().notRequired(),
          companyName: Yup.string().required(messages.MANDATORY_FIELD),
        });
      } else if (
        subjectType &&
        subjectType[0] &&
        subjectType[0][0] &&
        (subjectType[0][0].id === SUBJECT_TYPE_ENUM.OBRT || subjectType[0][0].id === SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST)
      ) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          mb: Yup.string()
            .required(messages.MANDATORY_FIELD)
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .max(11, messages.MB_MAX_LENGTH),
          companyName: Yup.string().required(messages.MANDATORY_FIELD),
        }).notRequired();
      }
    }),
    address: defaultAddressValidation,
  }),
  email: Yup.string().email('Neispravan format').notRequired(),
});

export const projectDocumentsCaseUuidToCopyFromSchema = Yup.object({
  caseUuidToCopyFrom: Yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!'),
});

export const projectDocumentWithNonMandatoryOibValidationSchema = Yup.object({
  projectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
  authorizationNumberExists: Yup.boolean().notRequired(),
  authorizedDesigner: Yup.object().when(['authorizationNumberExists'], keys => {
    return !keys[0]
      ? Yup.object({
        authorizationNumber: Yup.array().notRequired(),
      }).nullable()
      : Yup.object({
        authorizationNumber: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
      }).nullable();
  }),
  designerFirstName: Yup.string().when(['authorizationNumberExists'], (keys, schema) =>
    !keys[0] ? schema.required(messages.MANDATORY_FIELD) : schema.notRequired(),
  ),
  designerLastName: Yup.string().when(['authorizationNumberExists'], (keys, schema) =>
    !keys[0] ? schema.required(messages.MANDATORY_FIELD) : schema.notRequired(),
  ),
  oibFetched: Yup.boolean().notRequired(),
  designerOffice: Yup.object({
    subjectType: Yup.array().of(Yup.object()).min(1, messages.MANDATORY_FIELD),
    legalEntity: Yup.object().when(['subjectType', 'oibFetched'], keys => {
      if (keys && keys[0] && keys[0][0] && keys[0][0]?.id === SUBJECT_TYPE_ENUM.PRAVNA_OSOBA) {
        return Yup.object({
          oib: keys[1]
            ? Yup.string().required(messages.MANDATORY_FIELD).matches(/^\d+$/, messages.ONLY_DIGITS).length(11, messages.OIB_MIN_MAX_LENGTH)
            : Yup.string().notRequired(),
          companyName: Yup.string().required(messages.MANDATORY_FIELD),
        });
      } else if (keys && keys[0] && keys[0][0] && (SUBJECT_TYPE_ENUM.OBRT === keys[0][0]?.id || SUBJECT_TYPE_ENUM.SLOBODNA_DJELATNOST === keys[0][0]?.id)) {
        return Yup.object({
          oib: Yup.string().notRequired(),
          mb: Yup.string()
            .notRequired()
            .matches(/^\d+$/, messages.ONLY_DIGITS)
            .max(11, messages.MB_MAX_LENGTH),
          companyName: Yup.string().required(messages.MANDATORY_FIELD),
        }).notRequired();
      }
    }),
  }),
  email: Yup.string().email('Neispravan format').notRequired(),
});
